import { rankings } from '@/mocks/homeData';

export default function RankingSection() {
  const getTagStyle = (tag: string) => {
    if (tag === '爆') return 'bg-primary-500 text-background-50';
    if (tag === '热') return 'bg-accent-500 text-background-50';
    return 'bg-secondary-500 text-background-50';
  };

  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-fire-line"></i>
            热门排行
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">实时热度榜单</h2>
          <p className="mt-3 text-sm text-foreground-600">最受关注的爆料话题，热度实时更新</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl px-4 md:px-6 py-4 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-display text-sm flex-shrink-0 ${
                item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-200 text-foreground-700'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.time}</p>
              </div>
              {item.tag && (
                <span className={`px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${getTagStyle(item.tag)}`}>
                  {item.tag}
                </span>
              )}
              <span className="text-sm font-display text-accent-500 whitespace-nowrap hidden sm:block">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}